<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" class="container veterans" fxLayoutAlign="center center">
    <h2>Veterans behind ReSupply</h2>
    <p>
      ReSupply is proudly founded and led by Veterans who have left their military careers to continue serving their country in a different
      way. We strive to bring the same discipline and efficiency to help guide your cherished items to their next home.
    </p>
    <div class="carousel-wrapper">
      <ng-carousel #carouselRef="ngCarousel" [config]="carouselConfig" (itemIndexChange)="setItemIndex($event)">
        <ng-template [ngCarouselSlide]="carouselRef" let-item>
          <div fxLayout="column" class="carousel-item" fxLayoutAlign="center center">
            <div class="img-wrapper" style="background-image: url(/assets/split-screen-v3/people/{{ item.image }});"></div>
            <span>
              {{ item.name }}
            </span>
            <span>
              {{ item.role }}
            </span>
            <div class="carousel-img" fxLayoutAlign="end center">
              <img src="/assets/split-screen-v3/{{ item.icon }}.png" width="100px" />
            </div>
          </div>
        </ng-template>
      </ng-carousel>
      <div fxFlex fxLayoutAlign="center center">
        <div class="control-panel" fxLayout="row" fxLayoutAlign="space-between center">
          <button (click)="carouselRef.prev()" fxLayoutAlign="center center">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="indicator" fxLayout="row" fxLayoutAlign="center center">
            @for (item of carouselConfig.items; track item; let i = $index) {
              <div [class.active]="i === itemIndex"></div>
            }
          </div>
          <button (click)="carouselRef.next()" fxLayoutAlign="center center">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxFlex="100" class="buttons">
      <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="primary" (click)="goToPrimary(sectionType)">
        <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
    </div>
  </div>
</div>
